import { translate as t } from '@thoughtspot/i18n';
import { create } from '@thoughtspot/logger';
import { TSToChartEvent, } from '@thoughtspot/ts-chart-sdk';
import { ErrorTypes } from '../../../components/chart-error/chart-error.helper';
import { CustomChartError } from '../../../components/chart-error/chart-error.util';
import { sendMessage } from '../../../services/post-message-event-dispatcher';
import { validateCustomChartValidationEventResponsePayload } from '../../common/util';
const logger = create('ts-to-chart > event-callbacks > validate-visual-props');
export const validateCustomVisualProps = (commonProps, eventProps, emitEvent) => {
    const { iFrameWindow: iframeRef, appUrl } = commonProps;
    const { visualProps, updateCustomChartContext, activeColumnId, changeInfo, } = eventProps;
    const payload = {
        visualProps,
        activeColumnId,
        changeInfo,
    };
    return sendMessage(iframeRef, {
        eventType: TSToChartEvent.VisualPropsValidate,
        payload,
    }, appUrl).then(res => {
        const validationResponse = validateCustomChartValidationEventResponsePayload(res.data, logger);
        if (!validationResponse.isValid) {
            logger.error('Invalid response received from chart', validationResponse.validationErrorMessage);
            throw new CustomChartError(ErrorTypes.VISUAL_PROPS_VALIDATION_ERROR);
        }
        const { visualPropEditorDefinition, chartConfigEditorDefinition, isValid, customVisualProps, } = res.data;
        if (isValid) {
            updateCustomChartContext({
                updatedVisualPropEditorDefinition: visualPropEditorDefinition,
                updatedChartConfigEditorDefinition: chartConfigEditorDefinition,
            });
            return { isValid: true, customVisualProps };
        }
        let errorMessage = '';
        if (res.data.error) {
            if (Array.isArray(res.data.error)) {
                res.data.error.forEach((error) => {
                    if (error?.errorTranslation) {
                        errorMessage +=
                            t(error.errorTranslation) || error.errorMessage;
                        errorMessage += '\n';
                    }
                    else {
                        errorMessage += error;
                        errorMessage += '\n';
                    }
                });
                errorMessage = errorMessage.trim();
            }
            else {
                errorMessage = res.data.error;
            }
        }
        else if (res.data.validationErrorMessage) {
            if (Array.isArray(res.data.validationErrorMessage)) {
                res.data.validationErrorMessage.forEach((error) => {
                    if (error?.errorTranslation) {
                        errorMessage +=
                            t(error.errorTranslation) || error.errorMessage;
                        errorMessage += '\n';
                    }
                    else {
                        errorMessage += error;
                        errorMessage += '\n';
                    }
                });
                errorMessage = errorMessage.trim();
            }
            else {
                errorMessage = res.data.validationErrorMessage;
            }
        }
        else {
            errorMessage = 'Visual Props validation error : Empty message';
        }
        return { isValid: false, error: errorMessage };
    });
};
//# sourceMappingURL=index.js.map